import { onMounted } from 'vue';
import { commonApi } from '@shared/apis';

// 模拟登录
export const useMockLogin = () => {
  onMounted(async () => {
    // TODO 待确认环境变量  (可写入访问人id等参数)
    console.log(import.meta.env);
    if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MOCK_LOGIN === 'on') {
      await commonApi.mockLogin<any, any>({
        corpId: import.meta.env.VITE_DEV_SERVER_OPEN_CORP_ID,
        userId: import.meta.env.VITE_MOCK_LOGIN_USER_ID,
        visitorId: import.meta.env.VITE_MOCK_LOGIN_USER_VISITOR_ID ?? '', // 用于隐私协议需要访问人id写入上下文的情况
      });

      console.log('===> Mock Login On');
    }
  });
};
